
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConstantsService } from 'src/app/services/constants.service';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PlanAniosInterface } from '../models/plan.anios.interface';


@Injectable({
  providedIn: 'root'
})
export class AniosService  {
  public url = ConstantsService.ANIOS_URL;
  public urlPlanInst = ConstantsService.PLANES_INSTITUCIONALES_URL;
   constructor(private http:HttpClient) { }

  create(formData:any):Observable<any> {


      return this.http.post(`${this.url}`, formData).pipe(map(data => {
        return data;

      }));
    }

  list(query =''): Observable<any> {

    return this.http.get(`${this.url}${query}`).pipe(map(
     data => {return data;}
   ));
 }

  
  update(formData:any):Observable<any> {
    let {idSprAnio} = formData;
    return this.http.patch(`${this.url}${idSprAnio}`,formData).pipe(map(
      data => {
        return data;
      }
    ));
  }
  
    delete(dataDelete:any): Observable<any>{
      let editaEstadoAnios={
        ...dataDelete,
        delLog:"S"
      } 
      return this.http.patch(`${this.url}${dataDelete.idSprAnio}`,editaEstadoAnios ) }


    getDataPlanIns(query =''): Observable<any> {
      return this.http.get(`${this.urlPlanInst}${query}`).pipe(map(
        data => {return data;}
      ));
    }
    

   /*  getPlanAniosId(id: number): Observable<PlanAniosInterface> {
      return this.http.get<PlanAniosInterface>(`${this.url}/${id}`);    
    } */

  
}
